<template>
  <div>
    <div class="wrapper my-8 mx-8">
      <p>Dashboard</p>
      <h3 class="mt-6">Welcome back, Jim</h3>
      <v-row class="mt-3">
        <v-col cols="5">
          <div style="display:flex;flex-direction:column">
            <div class="cell">
                <div style="display:flex;flex-direction:column;flex:0.9;">
                    <p class="font-weight-bold">
                        Total Revenue
                    </p>
                    <div class="mt-3" style="display:flex;align-items:center">
                        <p class="display-1">
                            30.221$
                        </p>
                        <div class="ml-4" style="display:flex;flex-direction:column;">
                            <p style="color:rgb(35,193,116);font-size:13px;">+10%;</p>
                            <p style="font-size:13px;">from previous year</p>
                        </div>
                    </div>
                </div>
                <div style="justify-self:flex-end;">
                    <p>Year: <span style="color:black;">2019</span> (current)</p>
                </div>
            </div>
            <div class="cell mt-6" style="flex:0.1;">
                <p>hi</p>
            </div>
          </div>
        </v-col>
        <v-col cols="7">
          <div class="cell">
              <p>more hi</p>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  created(){
    this.$store.dispatch('setActiveIndex',1)
  }
}
</script>

<style scoped>
.wrapper {
  display: flex;
  flex-direction: column;
}

.cell{
    background-color: white;
    display: flex;
    padding: 40px 20px;
}


</style>